import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ThemeCssClass } from '../../components/atoms/theme-switcher/theme-switcher.component';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  // NG21-MIGRATION(stufe-2): kein <link>-Tausch mehr; PrimeNG-Preset mit darkModeSelector '.hyperion-dark' (ANGULAR_UPDATE_PLAN.md §8.2)
  switchTheme(theme: ThemeCssClass) {
    const themeLink = this.document.getElementById(
      'app-theme'
    ) as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = 'assets/themes/' + theme + '.css';
    }
  }
}
